import { transformPx2Rem, convertStyleData } from '@utils/tools';
import { customEvent } from '@utils/customEvent';

import './SuspensionCustomComponent.less';

export default function SuspensionCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  const wrapStyle = {
    backgroundImage: styleObj.backgroundImage,
    backgroundColor: styleObj.backgroundColor,
    bottom: styleObj.bottom,
    right: styleObj.right,
    opacity: styleObj.opacity
  }
  const textStyle = {
    fontSize: styleObj.fontSize,
    fontStyle: styleObj.fontStyle,
    fontWeight: styleObj.fontWeight,
    color: styleObj.color,
    textDecoration: styleObj.textDecoration,
  }
  /**
   * 组件特性数据处理
   */
  const customFeature = data.customFeature;
  const btnStyle = {
    margin: transformPx2Rem(customFeature['margin']/2,320),
  }
  const imgStyle = {
    borderRadius: data.style['border-radius'] ? data.style['border-radius'].replace('px', '') + '%' : data.style['border-radius'],
    width: transformPx2Rem(customFeature['img-size'],320),
    height: transformPx2Rem(customFeature['img-size'],320),
  }
  /**
   * 组件内容处理
   */   
  let content = data.content;
  /**
   * 返回组件
   */ 
  return (
    <div className={`custom-component suspension mode-${customFeature.mode}`} style={wrapStyle}>
      {content.map((item, index) => 
        <div className="suspension-btn" key={index} style={btnStyle} onClick={() => customEvent({customFeature: item.customFeature})}>
          {customFeature.openIcon &&
            <img className="btn-icon" style={imgStyle} src={item.pic} alt=""/>
          }
          {customFeature.openText &&
            <span style={textStyle}>{item.title}</span>
          }
        </div>
      )}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/suspension-custom-component/SuspensionCustomComponent.jsx